import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { Routes } from '@/assets/configs'
import type useIsQueryOwner from './useIsQueryOwner'

type QueryType = ReturnType<typeof useIsQueryOwner>[1]

const useConversationReservationBackNavigation = (type: QueryType) => {
  const router = useRouter()
  const isHandlingBack = useRef(false)

  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      if (isHandlingBack.current) return
      const conversation = router.query.conversation
      const conversationId = Array.isArray(conversation) ? conversation[0] : conversation
      const destination = new URL(url, window.location.origin)
      if (
        conversationId &&
        !destination.pathname.includes('/view-profile-petsitter/') &&
        destination.pathname.startsWith(Routes.PetSitter.Reservations.Base) &&
        !destination.pathname.includes('/new-request') &&
        !destination.pathname.includes('/payment')
      ) {
        if (
          destination.pathname === Routes.PetSitter.Reservations.Base &&
          destination.searchParams.get('conversation') === conversationId
        ) {
          return
        }

        isHandlingBack.current = true
        router.push({
          pathname: Routes.PetSitter.Reservations.Base,
          query: { conversation, type },
        })
      }
    }

    router.events.on('routeChangeStart', handleRouteChangeStart)
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
    }
  }, [router, type])
}

export default useConversationReservationBackNavigation
